import _ from '@/utils/lodash-optimized'

import http from './http'

const TIMEOUT = '500'

const url = ({ resource, path }) => `/igao/${resource}/${path}`

const get = params => http.getRequest(url(params))

const put = _.debounce(
  (params, resolve, reject) =>
    http
      .putRequest(url(params), _.pick(params, [ 'data' ]))
      .then(resolve)
      .catch(reject),
  TIMEOUT
)

const set = params =>
  new Promise((resolve, reject) => put(params, resolve, reject))

const resolve = params =>
  http.putRequest(`${url(params)}/resolve`, _.pick(params, [ 'data' ]))

const publish = params =>
  http.postRequest(url(params), _.pick(params, [ 'data' ]))

const read = params =>
  http.putRequest(`${url(params)}/read`, _.pick(params, [ 'data' ]))

const discard = ({ resource, path }) =>
  http.deleteRequest(`/igao/${resource}/${path}`)

export default {
  get,
  read,
  set,
  publish,
  resolve,
  discard
}
